import { useAdOverlayMatches } from '@app/modules/audit/modules/station-audit/hooks/useAdOverlayMatchs';
import { parseRangeFromTs } from '@mi-front/core';
import { useActiveStation } from '../../../../../../core/stations/hooks/useActiveStation';
import { useAuditMentionsMatches } from '../../../../../audit/modules/station-audit/hooks/useAuditMentionsMatches';
import { useAuditSpotMatches } from '../../../../../audit/modules/station-audit/hooks/useAuditSpotMatches';
import { useStreamSegmentsRange } from '../../hooks/segments/useStreamSegmentsQuery';
import { useStreamSettingsStore } from '../../stores/stream-screen-settings.store';

export function useRangeAuditResults() {
  const station = useActiveStation();
  const range = useStreamSegmentsRange();

  const matchesQuery = useAuditSpotMatches(station, parseRangeFromTs(range));
  const liveMentionsQuery = useAuditMentionsMatches(station, parseRangeFromTs(range));
  const adoverlayQuery = useAdOverlayMatches(station, parseRangeFromTs(range));
  const settingsAudit = useStreamSettingsStore((state) => state.audit);

  return {
    data: {
      matches: (settingsAudit.matches && matchesQuery.data) || [],
      liveMentions: (settingsAudit.liveMentions && liveMentionsQuery.data) || [],
      adoverlays: (settingsAudit.adoverlay && adoverlayQuery.data) || [],
    },
    reload: () => {
      matchesQuery.refetch();
      liveMentionsQuery.refetch();
      adoverlayQuery.refetch();
    },
  };
}
